import { Tooltip as MUITooltip, TooltipProps } from "@mui/material";

const Tooltip = ({ title, children, sx, ...rest }: TooltipProps) => {
  return (
    <MUITooltip
      componentsProps={{
        tooltip: {
          sx: {
            padding: "0.5rem 0.75rem",
            backgroundColor: "#393B3E",
            maxWidth: "12rem",
            '& .MuiTooltip-arrow': {
              color: "#393B3E"
            },
            ...sx
          },
        },
      }}
      title={title}
      {...rest}
    >
      {children}
    </MUITooltip>
  );
};

export { Tooltip };
export default Tooltip;
